<template>
  <a-card
    :bordered="false"
    class="header-solid h-full mb-40"
    :bodyStyle="{ paddingTop: '12px' }"
    style="background: transparent; box-shadow: none;"
  >
    <template #title>
      <a-row class="mb-0" type="flex" align="middle">
        <a-col :span="24" :md="20">
          <h6><a @click="$router.push('/hri')" class="mr-5">
              <a-icon type="arrow-left" /></a>&nbsp;Leave History Checking</h6>
          <!-- year filter -->
          <a-select
            show-search
            placeholder="Select a Fiscal year"
            option-filter-prop="children"
            style="width: 200px"
            :filter-option="filterOption"
            class="mt-10"
            v-model="FiscalYear"
          >
            <a-select-option
              v-for="line in optionsSelectYear"
              :key="line.id"
              :value="line.id"
            >
              {{ line.text }}
            </a-select-option>
          </a-select>
        </a-col>
      </a-row>
    </template>
    <!-- info -->
    <a-row :gutter="24" type="flex" align="stretch" class="mb-0">
      <a-col :span="24" :lg="14" class="h-full">
        <overview
          v-if="optionsSelectYear.length != 0"
          :FiscalYear="Number.parseInt(FiscalYear)"
          class="h-full"
        />
      </a-col>
      <a-col :span="24" :lg="10" class="h-full">
        <history
          v-if="optionsSelectYear.length != 0"
          :FiscalYear="Number.parseInt(FiscalYear)"
          class="h-full"
        />
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import overview from "./overview.vue";
import history from "./history.vue";
export default {
  components: {
    overview,
    history,
  },
  data() {
    return {
      FiscalYear: "",
      optionsSelectYear: [],
    };
  },
  mounted() {
    this.getYearList();
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    async getYearList() {
      this.optionsSelectYear = [];
      try {
        const res = await this.$http.get(`/hri/leave_of_absence/view_year/`);
        if (res.status === 200) {
          this.optionsSelectYear = res.data.map((item) => {
            return {
              id: item.year,
              text: `${item.year} / ${Number.parseInt(item.year) + Number.parseInt(543)}`,
            };
          });
          // sort
          this.optionsSelectYear.sort((a, b) => {
            return b.id - a.id;
          });
          // set select
          this.FiscalYear = this.optionsSelectYear[0].id;
        } else {
          const error = new Error('Request Failed');
          error.res = res;
          error.response = res;
          throw error;
        }
      } catch (error) {
        this.optionsSelectYear = [];
      }
    },
  },
};
</script>
